import React from 'react';
import { Grid } from '@mui/material';
import SalesPersonPagePanel from '~/components/SalesPersonPanelPiloto/SalesPersonPagePanel';
import OrderListPanel from '~/components/OrderListPanel';

const DesktopLayout = ({
    salesNumber,
    monthlySalesNumber,
    balanceText,
    quota,
    salesPercentage,
    indicatorsText,
    panelLoaded,
    ordersLoaded,
    orders,
    aggregatedOrdersByPeriod,
    brandFilter,
    setBrandFilter,
    chartData,
    dateRange,
}) => (
    <Grid container>
        <Grid item xs={12}>
            <SalesPersonPagePanel
                balanceText={balanceText}
                indicatorsText={indicatorsText}
                panelLoaded={panelLoaded}
                aggregatedOrdersByPeriod={aggregatedOrdersByPeriod}
                chartData={chartData}
                dateRange={dateRange}
                salesNumber={salesNumber}
                monthlySalesNumber={monthlySalesNumber}
                quota={quota}
                salesPercentage={salesPercentage}
            />
        </Grid>
        <Grid item xs={12}>
            <OrderListPanel
                orders={orders}
                brandFilter={brandFilter}
                setBrandFilter={setBrandFilter}
                ordersLoaded={ordersLoaded}
            />
        </Grid>
    </Grid>
);

export default DesktopLayout;
